export default __webpack_public_path__ + "static/media/individual.399c3467.png";